import { useState, useRef } from "react";
import { UploadImageIcon } from "../../../assets/UploadImageIcon";
import "./style.css";

const FALLBACK_ITEMS = [];

function ordenarPorAno(items) {
  return [...items].sort((a, b) => a.year - b.year);
}

export default function Timeline({ items: itemsProp, editMode, onError, onChange }) {
  const sourceItems = itemsProp?.length ? itemsProp : FALLBACK_ITEMS;
  // Durante a edição, preserve a posição dos marcos. Reordenar a cada tecla
  // fazia o item ativo mudar enquanto o ano ainda estava sendo digitado.
  const items = editMode ? sourceItems : ordenarPorAno(sourceItems);
  const [activeIndex, setActiveIndex] = useState(0);

  const total = items.length;
  const atual = items[activeIndex];
  const proximos = items.slice(activeIndex + 1, activeIndex + 3);

  const fileInputRef = useRef(null);


  const irParaAnterior = () => {
    setActiveIndex((i) => (i === 0 ? 0 : i - 1));
  };

  const irParaProximo = () => {
    setActiveIndex((i) => (i === total - 1 ? total - 1 : i + 1));
  };

  const handleAdicionar = () => {

    const novoItem = {
      year: String(new Date().getFullYear()),
      image: null,
      description: "",
    };

    onChange([...items, novoItem]);
    setActiveIndex(total);
  };

  const handleRemover = () => {
    if (!atual) return;

    const itemsAtualizados = items.map((item, index) =>
      index === activeIndex
        ? { ...item, markedForDeletion: !item.markedForDeletion }
        : item,
    );

    onChange(itemsAtualizados);
  };

  const handleItemChange = (field, value) => {
    const itemsAtualizados = items.map((item, index) =>
      index === activeIndex ? { ...item, [field]: value } : item
    );
    onChange(itemsAtualizados);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Gera URL temporária para exibição local imediata
    const previewUrl = URL.createObjectURL(file);

    const itemsAtualizados = items.map((item, index) =>
      index === activeIndex
        ? { ...item, image: { url: previewUrl }, newFile: file }
        : item
    );

    onChange(itemsAtualizados);
  };


  return (
    <section className="linha-tempo">
      <h2 className="linha-tempo__titulo">Linha do Tempo</h2>
      {editMode && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
          <button
            type="button"
            className="linha-tempo__add-btn"
            onClick={handleAdicionar}
          >
            + Adicionar linha do tempo
          </button>
        </div>
      )}

      <div className="linha-tempo__eixo" role="list">
        {items.map((item, i) => (
          <button
            key={item._id ?? `novo-${i}`}
            type="button"
            role="listitem"
            className={`linha-tempo__ano ${i === activeIndex ? "linha-tempo__ano--ativo" : ""} 
              ${item.markedForDeletion ? "linha-tempo__ano--deletado" : ""}`}
            onClick={() => setActiveIndex(i)}
            aria-current={i === activeIndex}
          >
            {item.year}
          </button>
        ))}
      </div>

      <div className="linha-tempo__filmstrip">
        <button
          type="button"
          className="linha-tempo__seta"
          onClick={irParaAnterior}
          disabled={total === 0 || activeIndex === 0}
          aria-label="Marco anterior da linha do tempo"
        >
          <svg viewBox="0 0 48 75" fill="none" aria-hidden="true">
            <path
              d="M37.3945 63.6064L10.6484 37.826L37.3945 10.6064"
              stroke="#00A0E6"
              strokeWidth="15"
              strokeLinecap="square"
            />
          </svg>
        </button>

        <div className="linha-tempo__fotos">
          <div className="linha-tempo__foto linha-tempo__foto--principal">
            {atual?.image?.url ? (
              <img src={atual.image.url} alt={`Marco de ${atual.year}`} />
            ) : (
              <div className="linha-tempo__foto-placeholder" />
            )}
          </div>

          {proximos.map((item, idx) => (
            <div key={item._id ?? `novo-${activeIndex + 1 + idx}`} className="linha-tempo__foto linha-tempo__foto--secundaria">
              {item.image?.url ? (
                <img src={item.image.url} alt={`Marco de ${item.year}`} />
              ) : (
                <div className="linha-tempo__foto-placeholder" />
              )}
            </div>
          ))}
        </div>

        <button
          type="button"
          className="linha-tempo__seta"
          onClick={irParaProximo}
          disabled={total === 0 || activeIndex === total - 1}
          aria-label="Próximo marco da linha do tempo"
        >
          <svg viewBox="0 0 48 75" fill="none" aria-hidden="true">
            <path
              d="M10.6055 63.6064L37.3516 37.826L10.6055 10.6064"
              stroke="#00A0E6"
              strokeWidth="15"
              strokeLinecap="square"
            />
          </svg>
        </button>
      </div>
      {editMode && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleImageUpload}
          />
          <button
            className="upload-image-btn"
            onClick={() => fileInputRef.current.click()}
            title="Substituir imagem atual"
          >
            <UploadImageIcon />
          </button>
        </div>
      )}
      <div
        className={`linha-tempo__legenda${atual?.markedForDeletion ? " linha-tempo__legenda--deletada" : ""
          }`}
      >
        {editMode ?
          (<>
            <h2 style={{ color: "#3759A5" }}>Descrição</h2>
            <textarea
              className="quem-somos-page-p__textarea"
              value={atual?.description || ""}
              onChange={(e) => handleItemChange("description", e.target.value)}
            />
            <h2 style={{ color: "#3759A5" }}>Ano</h2>
            <input
              type="text"
              inputMode="numeric"
              style={{ height: "30px", fontWeight: "800", fontSize: "1.2rem" }}
              className="quem-somos-page-p__textarea"
              value={atual?.year ?? ""}
              maxLength={4}
              onChange={(e) =>
                handleItemChange("year", e.target.value.replace(/\D/g, "").slice(0, 4))
              }
            />
          </>)
          : <p>{atual?.description}</p>}
      </div>
      {editMode && (
        <button
          type="button"
          className="linha-tempo__remover-btn"
          onClick={handleRemover}
        >
          {atual?.markedForDeletion ? "Desfazer remoção" : "Remover"}
        </button>
      )}
    </section>
  );
}
